export { Skeleton } from '@mantine/core'
